/**
 * @desc 数据匹配(新)
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/taxRefundMatching/dataMatch`, {
      method: "POST",

      ...options,
    }),
  );
}
